
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from '../components/explanations/dependent-prepositions-explanation';
const mainimage = '/Images/dependentpreps1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "dependentpreps" },
];

const DependentPrepositions = () => (
  <GrammarPageLayout
    level="B1"
    title="Dependent Prepositions"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Dependent Prepositions Exercises"
    seoDescription="Learn which prepositions follow specific verbs, adjectives, and nouns. B2 level practice."
    relatedCategory="grammar-exercises"
    relatedLevel="B2"
  />
);

export default DependentPrepositions;

